export default __webpack_public_path__ + "static/media/9.d81c8af5.svg";